module.exports = __webpack_public_path__ + "img/small-iphone.30c62dbe.png";